import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Reveal, SectionHeading, Seo, TimelineItem } from "@/components";
import { Container } from "@/layouts";
import { UPDATES } from "@/data";
import { ROUTES, normalizeLanguage, useLocalePath } from "@/navigations";
import { absoluteUrl, breadcrumbJsonLd, collectionJsonLd } from "@/utils/seo";

import shared from "@/styles/pages.module.css";
import styles from "./styles.module.css";

const UpdatesPage = memo(() => {
  const { t } = useTranslation("UpdatesPage");
  const { t: tSeo } = useTranslation("Seo");
  const { t: tc, i18n } = useTranslation("components");
  const lang = normalizeLanguage(i18n.language);
  const lp = useLocalePath();

  return (
    <>
      <Seo
        title={tSeo("updates.title")}
        description={tSeo("updates.description")}
        path={ROUTES.UPDATES}
        jsonLd={[
          collectionJsonLd(tSeo("updates.title"), tSeo("updates.description"), absoluteUrl(ROUTES.UPDATES, lang)),
          breadcrumbJsonLd(
            [
              { name: tc("nav.home"), path: ROUTES.HOME },
              { name: tc("nav.updates"), path: ROUTES.UPDATES },
            ],
            lang,
          ),
        ]}
      />

      <section className={shared.pageHeader}>
        <Container>
          <Reveal className={shared.pageHeaderInner}>
            <span className="eyebrow" data-reveal>
              {t("hero.eyebrow")}
            </span>
            <h1 className={shared.pageTitle} data-reveal>
              {t("hero.title")}
            </h1>
            <p className={shared.lede} data-reveal>
              {t("hero.lead")}
            </p>
          </Reveal>
        </Container>
      </section>

      <section className={shared.section}>
        <Container size="narrow">
          <SectionHeading title={t("list.title")} />
          <Reveal className={styles.timeline}>
            {UPDATES.map((u) => (
              <TimelineItem
                key={u.slug}
                date={t(`items.${u.slug}.date`)}
                tag={t(`items.${u.slug}.tag`)}
                title={t(`items.${u.slug}.title`)}
                summary={t(`items.${u.slug}.summary`)}
                to={lp(`${ROUTES.UPDATES}/${u.slug}`)}
              />
            ))}
          </Reveal>
        </Container>
      </section>
    </>
  );
});

UpdatesPage.displayName = "UpdatesPage";
export default UpdatesPage;
